import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { camHandler } from "../../FaceMesh/camHandler";
import DocumentGuideOverlay from "./DocumentGuideOverlay";

const CommonCapture = ({ setCaptureImage, handleClose, camList }) => {
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    setImageData(null);
    // Start camera when component mounts
    startCamera();
    return () => {
      setImageData(null);
      // Cleanup camera when component unmounts
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      const video = document.querySelector("#common-camera");
      if (video && camHandler.videoStrem) {
        video.srcObject = camHandler.videoStrem;
        await video.play();
      }
    } catch (error) {
      console.error("Error starting camera:", error);
    }
  };

  const stopCamera = () => {
    try {
      const video = document.querySelector("#common-camera");
      if (video && video.srcObject) {
        video.pause();
        video.srcObject = null;
      }
    } catch (error) {
      console.error("Error stopping camera:", error);
    }
  };

  const handleReCapture = () => {
    setImageData(null);
    startCamera();
  };

  const handleCapture = () => {
    if (imageData) {
      // Don't close modal here - let parent handle it after processing
      setCaptureImage({ primaryFile: imageData });
      setImageData(null);
    } else {
      const video = document.querySelector("#common-camera");
      const canvas = document.querySelector("#common-canvas");

      // Get the video dimensions
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      // Calculate the crop area (85% width, 60% height - same as the guide overlay)
      const cropWidth = videoWidth * 0.85;
      const cropHeight = videoHeight * 0.6;
      const cropX = (videoWidth - cropWidth) / 2;
      const cropY = (videoHeight - cropHeight) / 2;

      // Set canvas to the cropped size
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      const context = canvas.getContext("2d");

      // Draw only the cropped area from the video
      context.drawImage(
        video,
        cropX,
        cropY,
        cropWidth,
        cropHeight, // Source rectangle (from video)
        0,
        0,
        cropWidth,
        cropHeight // Destination rectangle (on canvas)
      );

      const dataURL = canvas.toDataURL("image/png");
      setImageData(dataURL);

      // Pause video after capture
      video.pause();
    }
  };

  const handlecamFlip = async () => {
    const video = document.getElementById("common-camera");
    video.pause();
    video.srcObject = null;

    await camHandler.flipCam();

    video.srcObject = camHandler.videoStrem;

    video.addEventListener(
      "canplay",
      async () => {
        video.play();
      },
      { once: true }
    );
  };

  const handleCaptureClose = () => {
    stopCamera();
    handleClose();
    setImageData(null);
  };

  return (
    <>
      <div className="bg_gray rounded mb-2">
        <div className="scanning_box position-relative overflow-hidden rounded-3">
          {/* <div
            className="bg_master2 end-0 font_14 lh-1 mt-2 me-2 zi_1 position-absolute px-3 py-2 br_5 text-white top-0 cursor-pointer hover"
            onClick={handleCaptureClose}
          >
            <span className="py-1 d-block">
              <i className="fas fa-times"></i>
            </span>
          </div> */}

          {/* Mobile Camera Controls - Camera Flip and Capture Button */}

          <video
            id="common-camera"
            className={`fd_streaming_video w-100 ${imageData && "d-none"}`}
            playsInline
            autoPlay
          />
          <canvas
            id="common-canvas"
            className={`fd_streaming_video w-100 ${!imageData && "d-none"}`}
          ></canvas>

          {/* Document Guide Overlay */}
          {!imageData && (
            <DocumentGuideOverlay
              width="85%"
              height="60%"
              instructionText="Align document within the frame"
            />
          )}

          <div className={`scannerline ${imageData && "d-none"}`}></div>
        </div>
      </div>

      <div>
        <div className="mt-2 d-flex justify-content-center gap-2 text-center">
          {imageData && (
            <button
              className="btn-t1 me-3 py-2 px-3 br_7 font_14"
              onClick={handleReCapture}
            >
              <i className="fas fa-redo me-2"></i>
              Re Capture
            </button>
          )}
          <button
            className="btn-master2 py-2 px-3 br_7 font_14"
            onClick={handleCapture}
          >
            <i
              className={`fas ${imageData ? "fa-check" : "fa-camera"} me-2`}
            ></i>
            {imageData ? "Proceed" : "Capture"}
          </button>
          {!imageData && (
            <div className="mobile-flip-button zi_1 gap-2">
              <div
                className="bg_master2 px-3 py-2 br_5 cursor-pointer hover d-flex align-items-center"
                onClick={handlecamFlip}
                title="Flip Camera"
              >
                <i className="fas fa-sync-alt text-white"></i>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CommonCapture;
